module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1013-85b3a1b857de9795009c20a2d7701179.png";